module.exports = "<textarea [(ngModel)]=\"desiredSlug\" (input)=\"checkSlugAvailability()\" placeholder=\"Slug\" (keydown.enter)=\"$event.preventDefault()\"></textarea>\n<mat-icon class=\"good\" *ngIf=\"checked && available\">check_circle_outline</mat-icon>\n<mat-icon class=\"warning\" *ngIf=\"checked && !available\">error_outline</mat-icon>\n<div class=\"message\">\n    <span>{{error}}</span>\n</div>"


//////////////////
// WEBPACK FOOTER
// /opt/atlassian/pipelines/agent/build/src/swarm/src/app/fields/slug.component.html
// module id = ../../../../../src/swarm/src/app/fields/slug.component.html
// module chunks = main